
class Base64 {

	/**
	 *  @param {Blob} blob
	 *  @returns {Promise<String>}
	 */
	static async fromBlob( blob ) {
		return new Promise( (resolve, reject) => {
			const reader = new FileReader();
			reader.onload = () => {
				resolve( reader.result );
			};

			reader.onerror = reject;
			reader.readAsDataURL( blob );
		});
	}

	/**
	 * @param {string} base64_text
	 * @returns {Uint8Array}
	 */
	static parse( base64_text ) {
		return Uint8Array.from( atob( base64_text ), c => c.charCodeAt(0) );
	}

	/**
	 * @param {string} base64_text
	 * @returns {Blob}
	 */
	static parseURI( data_uri ) {
		const [ prefix, data ] = data_uri.split(',');
		const mime = prefix.split(':')[1].split(';')[0];
		const bytes = this.parse( data );
		const blob = new Blob( [bytes], { type: mime } );
		return blob;
	}
}


module.exports = Base64